import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[85vh] flex items-center pt-12 pb-24 overflow-hidden" data-id="element-43">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-grid-pattern [mask-image:linear-gradient(to_bottom,white,transparent)] pointer-events-none" data-id="element-44" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-45">
        {/* Left Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start" data-id="element-46">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-950/50 border border-teal-800 text-teal-400 text-xs font-bold tracking-widest uppercase mb-6" data-id="element-47">
            <span className="w-2 h-2 rounded-full bg-teal-500 animate-pulse" data-id="element-48" />
            For Laid-Off Tech Pros
          </div>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.1] mb-6 text-zinc-50" data-id="element-49">
            THE "ANTI-RESUME" PIVOT: <br data-id="element-50" />
            <span className="text-teal-500" data-id="element-51">
              FLIP YOUR TECH LAYOFF INTO A $5K+ CONSULTING RETAINER
            </span>
          </h1>

          <h2 className="text-xl sm:text-2xl text-zinc-300 font-medium mb-8 leading-relaxed border-l-4 border-amber-500 pl-4" data-id="element-52">
            Stop begging for interviews and start selling outcomes. The tactical
            30-day map to bypass HR, skip the ATS black hole, and secure
            high-ticket contracts.
          </h2>

          <p className="text-zinc-400 text-lg mb-10 leading-relaxed max-w-xl" data-id="element-53">
            You woke up to a "termination of access" email. Your Slack is gone.
            Your benefits are ticking down. And the LinkedIn "Open to Work"
            banner feels more like a scarlet letter than a badge of honor.
            <br data-id="element-54" />
            <br data-id="element-55" />
            You've spent weeks screaming into the void of job boards, only to be
            ghosted by recruiters half your age. You aren't failing because you
            lack skills; you're failing because you're playing a rigged game
            designed to commoditize you.
          </p>

          <div className="w-full sm:w-auto flex flex-col gap-4" data-id="element-56">
            <a href="#offer" className="group relative inline-flex items-center justify-center px-8 py-5 text-lg font-bold text-zinc-950 bg-emerald-500 hover:bg-emerald-400 rounded-sm transition-all duration-200 overflow-hidden" data-id="element-57">
              <div className="absolute inset-0 w-full h-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-58" />
              <span className="relative flex items-center gap-2" data-id="element-59">
                GET THE PIVOT MAP — $11.33
                <Zap className="w-5 h-5" data-id="element-60" />
              </span>
            </a>
            <div className="flex items-center justify-center sm:justify-start gap-4 text-sm text-zinc-500 font-medium" data-id="element-61">
              <span className="flex items-center gap-1" data-id="element-62">
                <Zap className="w-4 h-4 text-amber-500" data-id="element-63" /> Instant digital
                delivery
              </span>
              <span className="flex items-center gap-1" data-id="element-64">
                <ShieldCheck className="w-4 h-4 text-teal-500" data-id="element-65" /> Secure
                checkout
              </span>
            </div>
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        rotate: -5
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative lg:ml-auto w-full max-w-lg mx-auto" data-id="element-66">
          <div className="absolute inset-0 bg-teal-500/20 blur-[100px] rounded-full" data-id="element-67" />
          <img src="https://cdn.magicpatterns.com/uploads/mVykxoF4mrrNZowEnNpwE3/the_IT_LSYOFF_PIVOP_MAP.png" alt="The IT Layoff Pivot Map on Tablet" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-68" />
        </motion.div>
      </div>
    </section>;
}